import React from 'react'
import styled from '@emotion/styled';

const InputGroup = ({name, value, handleChange, required}) => (
    <input 
        type="text"
        name={name}
        value={value}
        onChange={handleChange}
        className={required && !value ? "required" : ""}
    />
)

export default InputGroup;